module.exports = __webpack_public_path__ + "img/杜秋菁.a0a16f11.jpg";